import { createContext } from 'react';
import { createStore } from 'zustand';
import { CIAM_AUTHENTICATION_STATUS } from '../types';
import { buildRedirectUrl, isClientSide } from '../utils';
export const CiamContext = /*#__PURE__*/createContext(null);
export const createCiamStore = config => {
  const ciamStore = createStore()((set, get) => ({
    authenticationStatus: CIAM_AUTHENTICATION_STATUS.UNKNOWN,
    config,
    userInfo: null,
    getUserInfo: () => {
      return new Promise((resolve, reject) => {
        if (isClientSide()) {
          window.CIAM = window.CIAM || [];
          set({
            authenticationStatus: CIAM_AUTHENTICATION_STATUS.LOADING
          });
          window.CIAM.push(() => Promise.all([window.CIAM.getDecodedAccessToken(get().config.clientId), window.CIAM.getFullUserProfile(get().config.clientId), window.CIAM.getUserInfo(get().config.clientId), window.CIAM.getUserSubscriptions(get().config.clientId)]).then(_ref => {
            let [accessToken, fullIdentity, idToken, subscriptions] = _ref;
            if (accessToken && fullIdentity && idToken && subscriptions) {
              const userInfo = {
                accessToken,
                fullIdentity,
                idToken,
                subscriptions: subscriptions ?? [],
                tokens: {
                  access: window.CIAM.getAccessToken(get().config.clientId) ?? '',
                  id: window.CIAM.getIdToken(get().config.clientId) ?? ''
                }
              };
              set({
                authenticationStatus: CIAM_AUTHENTICATION_STATUS.AUTHENTICATED,
                userInfo
              });
              resolve(userInfo);
            } else {
              set({
                authenticationStatus: CIAM_AUTHENTICATION_STATUS.UNAUTHENTICATED,
                userInfo: null
              });
              resolve(null);
            }
          }).catch(() => {
            set({
              authenticationStatus: CIAM_AUTHENTICATION_STATUS.ERROR,
              userInfo: null
            });
            reject('Error while retrieving user info');
          }));
        } else {
          reject('You can only call getUserInfo() from the browser');
        }
      });
    },
    redirectToRegister: options => {
      const redirectUrl = buildRedirectUrl(new URL(`${window.location.origin}${get().config.redirectPaths.register}`), options);
      window.location.assign(redirectUrl);
    },
    redirectToSignIn: options => {
      const redirectUrl = buildRedirectUrl(new URL(`${window.location.origin}${get().config.redirectPaths.login}`), options);
      window.location.assign(redirectUrl);
    },
    redirectToSignOut: options => {
      const redirectUrl = buildRedirectUrl(new URL(`${window.location.origin}${get().config.redirectPaths.logout}`), options);
      window.location.assign(redirectUrl);
    }
  }));
  return ciamStore;
};